angular.module('zc.projects')

.directive 'campaignDynamicView', ($q, $sce, CampaignTemplate) ->
  restrict: 'E'
  scope:
    campaign: '='
    form: '='
    viewClass: '@'
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_dynamic_view.html'
  link: (scope, element, attrs) ->

    setTemplateValid = (valid) ->
      return unless scope.form
      scope.form.$setValidity 'template', valid

    updateView = ->
      return unless scope.campaign.template_type
      params =
        project_id: scope.campaign.project_id
        campaign_id: scope.campaign.id
        incentive_ids: scope.campaign.incentives.map (incentive) -> incentive.id
        template_type: scope.campaign.template_type
        message: scope.campaign.element.message
        campaign_type: scope.campaign.campaign_type
      promises = [
        CampaignTemplate.views angular.extend(params)
        CampaignTemplate.confirmJs(params)
        CampaignTemplate.css angular.extend(params)
        CampaignTemplate.confirmCss(params)
      ]
      $q.all(promises).then ([views, js, csss...]) ->
        # only append view containing div
        $view = $('<div>')
        for view in views
          $view.append(view.view)

        coupon_code = scope.campaign.current_incentive?.coupon_code or 'COUPON CODE'
        if scope.campaign.current_incentive?.incentive_type == 'unique_coupon_code'
          coupon_code = 'UNIQUE CODE'

        if !scope.campaign.current_incentive? and scope.campaign.incentives?
          now = new Date()
          nearest_diff = Number.MAX_VALUE

          for incentive in scope.campaign.incentives
            diff = Math.abs(incentive.start_at - now)
            if diff < nearest_diff
              coupon_code = incentive.coupon_code
              nearest_diff = diff

        $view.find('.zc_code_insert_code').text(coupon_code)
        scope.view = $sce.trustAsHtml($view.html()) # currently there is only one view
        # add random number that ensures that js content has changed and re-executed
        scope.js = $sce.trustAsHtml("<script data-random=\"#{Math.random()}\">#{js}</script>")
        scope.css = csss.join('\n')
        scope.hasError = false
        setTemplateValid true
      , (err) ->
        scope.hasError = true
        setTemplateValid false

    scope.$watch 'campaign.element', updateView, true
    scope.$watch 'campaign.incentives', updateView, true



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/campaign_dynamic_view.coffee